var $79ae244e9d286cb7$exports = {};
$79ae244e9d286cb7$exports = {
    "dismiss": `\u{95DC}\u{9589}`
};


export {$79ae244e9d286cb7$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
